import { render, staticRenderFns } from "./PreviewSize.vue?vue&type=template&id=24fd6af8&"
import script from "./PreviewSize.vue?vue&type=script&lang=ts&"
export * from "./PreviewSize.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewSize.vue?vue&type=style&index=0&id=24fd6af8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports